import { FaInstagram, FaTiktok } from 'react-icons/fa';
import './Footer.css';
import React from 'react';

/* Added the anchor tags with the appropriate href, target='_blank', and rel='noreferrer' attributes, 
so clicking on the Instagram and TikTok icons, will open the respective pages in a new tab. */

const Footer = () => {
  return (
    <div className='footer foreground'>
      <div className='footer-contact'>
        <div className='footer-contactInfo-container'>
          <div className='footer-contact-header'>CONTACT US!</div>
          <div className='footer-contact-email'>contact@tricitieslocal.com</div>
          <div className='footer-contact-phone'>423-707-9913</div>
        </div>
      </div>

      <div className='footer-message-container'>
        <p className='footer-business-message'>
          Reach out to us on how to get <strong>your</strong> business featured on Tri-Cities Local for FREE!
        </p>
        <a href='https://docs.google.com/forms/d/1r0Cf6J-OBf_fc7nGSzv15k4bWujhC7x80Lvosn1ZGR8/viewform?edit_requested=true' target='_blank' rel='noreferrer' className='footer-button'>
          Get Featured
        </a>
      </div>

      <div className='footer-social-container'>
        <a href='https://www.instagram.com/tri_cities_local' target='_blank' rel='noreferrer' className='footer-social'>
          <FaInstagram className='footer-social-icon'/>
          <span className='footer-social-text'>tri_cities_local</span>
        </a>
        <a href='https://www.tiktok.com/@tri.cities.local' target='_blank' rel='noreferrer' className='footer-social'>
          <FaTiktok className='footer-social-icon'/>
          <span className='footer-social-text'>tri.cities.local</span>
        </a>
      </div>
    </div>
  );
}

export default Footer;